import { useAuthStore } from '../../../features/auth/store';
import StudentDashboard from './StudentDashboard';
import TeacherDashboard from './TeacherDashboard';
import AdminDashboard from './AdminDashboard';
import PrincipalDashboard from './PrincipalDashboard';

export default function DashboardPage() {
  const user = useAuthStore((s) => s.user);
  switch (user?.role) {
    case 'STUDENT': return <StudentDashboard />;
    case 'TEACHER': return <TeacherDashboard />;
    case 'ADMIN': return <AdminDashboard />;
    case 'PRINCIPAL': return <PrincipalDashboard />;
    default: return null;
  }
}
